import { NgModule } from '@angular/core';

import { SharedDependenciesModule } from '../shared/index';

import { AccessForbiddenComponent } from './access-forbidden/access-forbidden.component';
import { HomeRouting } from './home.routing';
import { HomeBrowserSupportModalComponent } from './home/home-browser-support/home-browser-support-modal.component';
import { HomeInstallerComponent } from './home/home-installer/home-installer.component';
import { HomeComponent } from './home/home.component';
import { StatusComponent } from './status/status.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ViDswFooterComponent } from '../shared/+design-system-web/vi-dsw-footer/vi-dsw-footer.component';
import { ViHeaderDomainModule } from '@vi-succ/vi-header-domain';
import { environment } from 'src/environments/environment';
import { DswLoginComponent } from '@vi-succ/design-system-web';

@NgModule({
  imports: [
    SharedDependenciesModule,
    HomeRouting,
    ViHeaderDomainModule.forRoot({
      baseUrl: environment.headerModuleApiUrl,
      accountAppUrl: environment.accountApiUrl,
      appId: environment.oAuthConfig.clientId,
    }),
    ViDswFooterComponent,
    DswLoginComponent,
  ],
  declarations: [
    HomeComponent,
    HomeInstallerComponent,
    NotFoundComponent,
    HomeBrowserSupportModalComponent,
    AccessForbiddenComponent,
    StatusComponent,
  ],
})
export class HomeModule {}
